import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HospitalStateService } from '../services/hospitalstate.service';
import { LoginService } from '../login.service';
import { FORCED_NAV } from './forced-nav';

type LogoutState = 'idle' | 'inFlight';

@Injectable({ providedIn: 'root' })
export class LogoutService {
  private readonly _http = inject(HttpClient);
  private readonly _router = inject(Router);
  private readonly _hospital = inject(HospitalStateService);
  private readonly _login = inject(LoginService);

  private readonly _state = signal<LogoutState>('idle');
  private _inFlight: Promise<void> | null = null;

  readonly state = this._state.asReadonly();

  get isLoggingOut(): boolean {
    return this._state() === 'inFlight';
  }

  logout(): Promise<void> {
    if (this._inFlight) {
      return this._inFlight;
    }

    this._state.set('inFlight');
    this._inFlight = this._run();
    return this._inFlight;
  }

  private async _run(): Promise<void> {
    try {
      await firstValueFrom(
        this._http.post(
          `${environment.baseURl}/Auth/logout`,
          {},
          { withCredentials: true }
        )
      );
    } catch {
      // server didn't ack — log out locally anyway
    } finally {
      this._clearSession();
      await this._router.navigate(['authentication/login'], FORCED_NAV);
      // state stays 'inFlight' until bootstrap — prevents canDeactivate races
    }
  }

  private _clearSession(): void {
    this._hospital.clearHospital();
    this._login.clearSession();
  }
}
